export const comments_3257649 = {"data":{"data":[],"links":{}}}